import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Progress bar with terracotta primary color and optional glow effect.
 *
 * @example
 * <om-progress-bar [value]="78" [showGlow]="true" />
 */
@Component({
  selector: 'om-progress-bar',
  imports: [],
  templateUrl: './progress-bar.html',
  styleUrl: './progress-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar {
  value = input.required<number>();
  showGlow = input<boolean>(false);
  color = input<'primary' | 'slate'>('primary');

  protected fillClasses = computed(() => {
    const colorClass = this.color() === 'primary' ? 'bg-primary' : 'bg-slate-500';
    const glowClass = this.showGlow() ? 'shadow-[0_0_10px_rgba(224,122,95,0.5)]' : '';
    return `h-full rounded-full transition-all duration-500 ${colorClass} ${glowClass}`.trim();
  });

  protected clampedValue = computed(() => Math.min(100, Math.max(0, this.value())));
}
